import { getS3PdfWithLocale } from '../lib/helpers'
import { getS3PdfWithLocaleIDS } from '../lib/helpers'
// Error codes

export const UNAUTHORIZED = 'unauthorized'
export const NOT_FOUND = 'notFound'
export const FORBIDDEN = 'forbidden'
export const CANCELED = 'canceled'
export const NETWORK_ERROR = 'networkError'
export const CONFLICT = 'conflict'
export const UNAVAILABLE = 'UNAVAILABLE'

export const systemRequirementsUrl = getS3PdfWithLocale('IDS_MDARS_System_Requirements')

export const hardwareRequirementsUrl = getS3PdfWithLocale('MDSFA_MMP_Hardware_Process')

export const mdarsUserManualUrl = getS3PdfWithLocale('MDARS_User_Guide')

export const mdarsDownloadInstructionsUrl = getS3PdfWithLocale('MDARS_Download_Instructions')

export const trainingCourseListUrl = getS3PdfWithLocale('Course_Listing')

export const idsUserManualUrl = getS3PdfWithLocale('IDS_Users_Manual')

export const idsCalFilesInstructionsUrl = getS3PdfWithLocale('IDS_Calibration_File_Tool_Installation_Instructions_Aftermarket')

export const idsMissingCalFilesInstructionsUrl = getS3PdfWithLocaleIDS('Cal File Download from Web')



// WEBPACK FOOTER //
// ./constants/index.js